import React from "react"

import { useStaticQuery, graphql } from "gatsby"
import PropTypes from "prop-types"

import * as styles from "./pagination.module.scss"
import Button from "../../atoms/button"
import Icon from "../../atoms/icon"

const Pagination = ({ prevPage, nextPage }) => {
  const { allSanityDictionary } = useStaticQuery(graphql`
    {
      allSanityDictionary {
        nodes {
          key {
            current
          }
          value
        }
      }
    }
  `)
  return (
    <div className={styles.pagination}>
      {prevPage ? (
        <div className={styles.button}>
          <Button url={prevPage}>
            <Icon icon="chevron_left" />
            {
              allSanityDictionary.nodes.find(
                (item) => item.key.current === "prev_stories"
              )?.value
            }
          </Button>
        </div>
      ) : (
        ""
      )}
      {nextPage ? (
        <div className={styles.button}>
          <Button url={nextPage}>
            {
              allSanityDictionary.nodes.find(
                (item) => item.key.current === "more_stories"
              )?.value
            }
            <Icon icon="chevron_right" />
          </Button>
        </div>
      ) : (
        ""
      )}
    </div>
  )
}

export default Pagination

Pagination.propTypes = {
  prevPage: PropTypes.string,
  nextPage: PropTypes.string,
}

Pagination.defaultProps = {
  prevPage: null,
  nextPage: null,
}
